import i18n from "i18next";
import XHR from "i18next-xhr-backend";
import { initReactI18next } from 'react-i18next';

import translationEn from "./locales/en/translation.json";
import translationCn from "./locales/cn/translation.json";
import { getDomainLanguage, setDocumentTitle } from "./utils/domainLanguage";
import { domainLanguageDetector } from "./utils/domainLanguageDetector";

// Get the domain-based default language
const domainLanguage = getDomainLanguage();

i18n
  .use(XHR)
  .use(domainLanguageDetector) // Use custom domain language detector
  .use(initReactI18next)
  .init({
    debug: false,
    lng: domainLanguage, // Use domain-based language
    fallbackLng: "en",

    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translations: translationEn,
      },
      cn: {
        translations: translationCn,
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
    react: {
      useSuspense: false
    }
  });

// Set document title based on the current language
i18n.on('languageChanged', (lng) => {
  setDocumentTitle(lng);
});

// Set initial document title
setDocumentTitle(domainLanguage);

export default i18n;